import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import { useSede } from 'context/SedeContext';

const KeyMetrics = ({ data }) => {
  const { getSelectionText } = useSede();
  

  // Helper function to safely format currency values
  const formatCurrency = (value) => {
    const numValue = parseFloat(value) || 0;
    return `Q ${numValue.toFixed(2)}`;
  };

  // Calcular total de asistencias
  const totalAttendance = (data?.attendanceStats?.attended || 0) + (data?.attendanceStats?.no_show || 0);
  const attendanceRate = totalAttendance > 0 ? ((data?.attendanceStats?.attended || 0) / totalAttendance * 100) : 0;

  // Calcular ingresos del mes actual (suma del array monthlyRevenue)
  const currentMonthRevenue = data?.monthlyRevenue?.reduce((sum, month) => sum + (month.total_amount || 0), 0) || 0;

  const metrics = [
    {
      title: 'Reservas Hoy',
      value: data?.todayBookings || 0,
      icon: '📅',
      color: 'primary',
      subtitle: 'Reservas del día'
    },
    {
      title: 'Ingresos Hoy',
      value: formatCurrency(data?.todayRevenue),
      icon: '💰',
      color: 'success',
      subtitle: 'Ingresos del día'
    },
    {
      title: 'Clientes Activos',
      value: data?.activeClients || 0,
      icon: '👥',
      color: 'info',
      subtitle: 'Con membresía activa'
    },
    {
      title: 'Nuevos Este Mes',
      value: data?.newClients || 0,
      icon: '🆕',
      color: 'warning',
      subtitle: 'Clientes nuevos'
    },
    {
      title: 'Ingresos del Mes',
      value: formatCurrency(currentMonthRevenue),
      icon: '📊',
      color: 'primary',
      subtitle: 'Total mensual'
    },
    {
      title: 'Ingresos Históricos',
      value: formatCurrency(data?.totalRevenue),
      icon: '🏆',
      color: 'secondary',
      subtitle: 'Total acumulado'
    },
    {
      title: 'Asistencia',
      value: `${attendanceRate.toFixed(1)}%`,
      icon: '✅',
      color: 'success',
      subtitle: 'Tasa de asistencia'
    },
    {
      title: 'Total Asistencias',
      value: data?.attendanceStats?.attended || 0,
      icon: '🎯',
      color: 'info',
      subtitle: 'Clases asistidas'
    },
    {
      title: 'No Shows',
      value: data?.attendanceStats?.no_show || 0,
      icon: '❌',
      color: 'danger',
      subtitle: 'Faltas'
    },
    {
      title: 'Membresías',
      value: data?.membershipStats?.length || 0,
      icon: '🎫',
      color: 'warning',
      subtitle: 'Tipos activos'
    },
    {
      title: 'Pagos Recientes',
      value: data?.recentPayments?.length || 0,
      icon: '💳',
      color: 'primary',
      subtitle: 'Últimos pagos'
    },
    {
      title: 'Métodos Pago',
      value: data?.paymentMethods?.length || 0,
      icon: '🏦',
      color: 'secondary',
      subtitle: 'Tipos de pago'
    }
  ];

  return (
    <div className="mb-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-1" style={{ color: '#2c3e50', fontWeight: '600' }}>Métricas Principales</h4>
          <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>Resumen de indicadores clave del negocio</p>
        </div>
      </div>
      
      <Row>
        {metrics.map((metric, index) => (
          <Col key={index} lg="2" md="3" sm="4" xs="6" className="mb-3">
            <Card className="h-100" style={{ 
              border: 'none',
              boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
              borderRadius: '16px',
              transition: 'all 0.3s ease',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
            }}>
              <CardBody className="text-center p-3">
                <div className="d-flex align-items-center justify-content-center mb-2">
                  <div style={{ 
                    fontSize: '1.8rem',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                  }}>
                    {metric.icon}
                  </div>
                </div>
                <h3 className="mb-1" style={{ 
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#2c3e50',
                  lineHeight: '1.2'
                }}>
                  {metric.value}
                </h3>
                <h6 className="mb-1" style={{ 
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#495057',
                  textTransform: 'uppercase',
                  letterSpacing: '0.3px'
                }}>
                  {metric.title}
                </h6>
                <small className="text-muted" style={{ 
                  fontSize: '0.7rem',
                  fontWeight: '500'
                }}>
                  {metric.subtitle}
                </small>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default KeyMetrics;
